import useMultpleTable from '../../../hooks/useMultipleTable';
import { Table } from '../../Table';
import { MultiTableComponentProps } from '../types';

const columnLables = {
  share_class_name: {
    name: 'Share Class Name'
  },
  share_class_national_code: {
    name: 'National Competent Authority Code'
  },
  share_class_identifier_isin: {
    name: 'ISIN'
  },
  share_class_identifier_cusip: {
    name: 'CUSIP'
  },
  share_class_identifier_sedol: {
    name: 'SEDOL'
  },
  share_class_identifier_ticker: {
    name: 'Bloomberg'
  },
  share_class_identifier_ric: {
    name: 'RIC'
  },
  share_class_flag: {
    name: 'Share Class Flag',
    withoutLetter: true
  }
};

export function ShareClasses({
  funds,
  currentDataKey,
  onChangeFund,
  schema,
  isStaticTemplate,
  isMultiFunds,
  onAddColumn,
  onDeleteColumn
}: MultiTableComponentProps) {
  const {
    rows: rows,
    columns: columns,
    onChange: onChange
  } = useMultpleTable({
    data: funds[currentDataKey]?.fund_data?.SHARE_CLASSES,
    onChangeFund,
    schema: schema.SHARE_CLASSES,
    isStaticTemplate,
    requiredFields: funds[currentDataKey]?.required_tables?.SHARE_CLASSES?.field_names || [],
    isMultiFunds,
    funds,
    onAddColumn,
    onDeleteColumn,
    columnLables,
    tableName: 'SHARE_CLASSES',
    order: 27 as any
  });

  return (
    <Table
      id="fca-reporttables-share-classes-table"
      handleChanges={onChange}
      columns={columns}
      rows={rows}
      stickyLeftColumns={isMultiFunds && Object.keys(funds).length > 2 ? 3 : null}
      stickyTopRows={isMultiFunds ? 1 : null}
    />
  );
}
